import { PR_STATUSES } from "@/lib/constants";

const STYLES = {
  borrador:  "bg-slate-100 text-slate-700",
  emitida:   "bg-emerald-100 text-emerald-800",
  cancelada: "bg-red-100 text-red-800",
};

export function PrStatusBadge({ status }) {
  const cfg = PR_STATUSES.find((s) => s.value === status);
  return (
    <span className={`inline-flex items-center rounded-full px-2 py-0.5 text-[11px] font-medium ${STYLES[status] || STYLES.borrador}`}>
      {cfg?.label || status}
    </span>
  );
}
